module.exports = __webpack_public_path__ + "media/images/pic/lectors/patrycja-palka-a6a7b5c73482d8707c2ef0c04b27be30.jpeg";